import React, { FC } from 'react';
import { ProductMainPrice } from 'src/components/BundleProduct/ProductMainPrice';

import classes from './Customisation.scss';
import { StepContainer } from './StepContainer';

type Props = {
    customisationFee: number;
};

export const OneTimeSetupFee: FC<Props> = ({ customisationFee }) => {
    return (
        <StepContainer className={classes.wrapper}>
            <div className={classes.oneTimeSetupFeeContainer}>
                <div className={classes.oneTimeSetupFeeTitle}>One-time new logo setup fee</div>
                <div>
                    <div className={classes.currentPrice}>
                        <ProductMainPrice
                            price={{
                                price: customisationFee,
                                price_incl: customisationFee,
                            }}
                        />
                    </div>
                    <div className={classes.emptyContainer}></div>
                </div>
            </div>
        </StepContainer>
    );
};
